<template>
 <el-card class="box-card form-screen mb-50">
    <el-row>
      <el-col :span="24">
        <div class="card-header" v-if="company && company.id">
          <span class="font-weight-700">{{ $t('companies.form.input_labels.id') }} {{ company.id }}</span>
          <hr>
        </div>
        <el-form :rules="rules" :model="form" ref="form" id="form" method="post" :action="urls.action">
          <el-form-item prop="name" :error="getErrorForField('name', errors)">
            <label slot="label" class="el-form-item__label">{{ $t('companies.form.input_labels.name') }} <span class="text-required">{{ $t('required') }}</span></label>
            <el-input v-model="form.name" :placeholder="$t('companies.form.input_placeholder.name')" name="name" @blur="trim('name')" class="w-340"></el-input>
          </el-form-item>
          <el-form-item prop="industries" :error="getErrorForField('industries', errors)">
            <label slot="label" class="el-form-item__label">{{ $t('companies.form.input_labels.industries') }} <span class="text-required">{{ $t('required') }}</span></label>
            <el-select
              v-model="form.industries"
              :placeholder="$t('companies.form.input_placeholder.industries')"
              multiple class="input-size-189"
              @blur="validateSelect('industries')"
              @change="checkRequiredIndustries"
            >
              <el-option v-for="item in industries" :key="item.id" :label="item.name" :value="item.id" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="representative_name" :error="getErrorForField('representative_name', errors)">
            <label slot="label" class="el-form-item__label">{{ $t('companies.form.input_labels.representative_name') }} <span class="text-required">{{ $t('required') }}</span></label>
            <el-input name="representative_name" v-model="form.representative_name" :placeholder="$t('companies.form.input_placeholder.representative_name')" @blur="trim('representative_name')" class="w-340"></el-input>
          </el-form-item>
          <el-form-item prop="zip_code" :error="getErrorForField('zip_code', errors)" class="input-size-305">
            <label slot="label" class="el-form-item__label">{{ $t('companies.form.input_labels.zip_code') }} <span class="text-required">{{ $t('required') }}</span></label>
            <el-input name="zip_code" v-model="form.zip_code" :placeholder="$t('companies.form.input_placeholder.zip_code')" @input="handleZipcode"></el-input>
         </el-form-item>
          <el-button class="btn-form mt-20" @click="getAddressByZipcode">{{ $t('companies.form.btn_search_by_zip_code' )}}</el-button>
          <el-form-item prop="prefecture_id" :error="getErrorForField('prefecture_id', errors)">
            <label slot="label" class="el-form-item__label">{{ $t('companies.form.input_labels.prefectures') }} <span class="text-required">{{ $t('required') }}</span></label>
            <el-select
              v-model="form.prefecture_id"
              :placeholder="$t('companies.form.input_placeholder.prefectures')"
              class="input-size-195"
              @blur="validateSelect('prefecture_id')"
              @change="$refs['form'].clearValidate('prefecture_id')"
            >
              <el-option v-for="item in prefectures" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="city" :error="getErrorForField('city', errors)" class="input-size-454">
            <label slot="label" class="el-form-item__label">{{ $t('companies.form.input_labels.city') }} <span class="text-required">{{ $t('required') }}</span></label>
            <el-input name="city" v-model="form.city" :placeholder="$t('companies.form.input_placeholder.city')" @blur="trim('city')"></el-input>
          </el-form-item>
          <el-form-item prop="address_number" :error="getErrorForField('address_number', errors)" class="input-size-454">
            <label slot="label" class="el-form-item__label">{{ $t('companies.form.input_labels.address_number') }}</label>
            <el-input name="address_number" v-model="form.address_number" :placeholder="$t('companies.form.input_placeholder.address_number')" @blur="trim('address_number')"></el-input>
          </el-form-item>
          <el-form-item prop="house" :error="getErrorForField('house', errors)" class="input-size-454">
            <label slot="label" class="el-form-item__label">{{ $t('companies.form.input_labels.house') }}</label>
            <el-input name="house" v-model="form.house" :placeholder="$t('companies.form.input_placeholder.house')" @blur="trim('house')"></el-input>
          </el-form-item>
          <el-form-item prop="tel" :error="getErrorForField('tel', errors)" class="input-size-454">
            <label slot="label" class="el-form-item__label">{{ $t('companies.form.input_labels.tel') }} <span class="text-required">{{ $t('required') }}</span></label>
            <el-input name="tel" v-model="form.tel" :placeholder="$t('companies.form.input_placeholder.tel')" @blur="trim('tel')"></el-input>
          </el-form-item>
          <el-form-item prop="mail_address" :error="getErrorForField('mail_address', errors)" class="input-size-454">
            <label slot="label" class="el-form-item__label">{{ $t('companies.form.input_labels.mail_address') }} <span class="text-required">{{ $t('required') }}</span></label>
            <el-input name="mail_address" v-model="form.mail_address" :placeholder="$t('companies.form.input_placeholder.mail_address')" @blur="trim('mail_address')" class="w-454"></el-input>
          </el-form-item>
          <el-form-item prop="homepage_url" class="input-size-454">
            <label slot="label" class="el-form-item__label">{{ $t('companies.form.input_labels.homepage_url') }}</label>
            <el-input name="homepage_url" v-model="form.homepage_url" :placeholder="$t('companies.form.input_placeholder.homepage_url')" @blur="trim('homepage_url')"></el-input>
          </el-form-item>
          <el-form-item prop="memo" :error="getErrorForField('memo', errors)" class="input-size-454">
            <label slot="label" class="el-form-item__label">{{ $t('companies.form.input_labels.memo') }}</label>
            <el-input name="memo" v-model="form.memo" :placeholder="$t('companies.form.input_placeholder.memo')" @blur="trim('memo')"></el-input>
          </el-form-item>
          <div class="group-input"><span>{{ $t('companies.form.bank_info') }}</span></div>
          <el-form-item prop="bank_name" :error="getErrorForField('bank_name', errors)" class="input-size-454">
            <label slot="label" class="el-form-item__label">{{ $t('companies.form.input_labels.bank_name') }} <span class="text-required">{{ $t('required') }}</span></label>
            <el-input name="bank_name" v-model="form.bank_name" :placeholder="$t('companies.form.input_placeholder.bank_name')" @blur="trim('bank_name')"></el-input>
          </el-form-item>
          <el-form-item prop="branch_name" :error="getErrorForField('branch_name', errors)" class="input-size-454">
            <label slot="label" class="el-form-item__label">{{ $t('companies.form.input_labels.branch_name') }} <span class="text-required">{{ $t('required') }}</span></label>
            <el-input name="branch_name" v-model="form.branch_name" :placeholder="$t('companies.form.input_placeholder.branch_name')" @blur="trim('branch_name')"></el-input>
          </el-form-item>
          <el-form-item prop="bank_account_type" :error="getErrorForField('bank_account_type', errors)" class="input-size-454">
            <label slot="label" class="el-form-item__label">{{ $t('companies.form.input_labels.bank_account_type') }} <span class="text-required">{{ $t('required') }}</span></label>
            <el-radio-group v-model="form.bank_account_type">
                <el-radio label="1" name="bank_account_type">{{ $t('companies.form.back_account_type.nomarl_account') }}</el-radio>
                <el-radio label="2" name="bank_account_type">{{ $t('companies.form.back_account_type.current_account') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item prop="bank_account" :error="getErrorForField('bank_account', errors)" class="input-size-454">
            <label slot="label" class="el-form-item__label">{{ $t('companies.form.input_labels.bank_account') }} <span class="text-required">{{ $t('required') }}</span></label>
            <el-input name="bank_account" v-model="form.bank_account" :placeholder="$t('companies.form.input_placeholder.bank_account')" @blur="trim('bank_account')"></el-input>
          </el-form-item>
          <el-form-item prop="bank_account_holder" :error="getErrorForField('bank_account_holder', errors)" class="input-size-454">
            <label slot="label" class="el-form-item__label">{{ $t('companies.form.input_labels.bank_account_holder') }} <span class="text-required">{{ $t('required') }}</span></label>
            <el-input name="bank_account_holder" v-model="form.bank_account_holder" :placeholder="$t('companies.form.input_placeholder.bank_account_holder')" @blur="trim('bank_account_holder')"></el-input>
          </el-form-item>
          <div class="group-input"><span>{{ $t('companies.form.account_info') }}</span></div>
          <el-form-item prop="login_id" :error="getErrorForField('login_id', errors)" class="input-size-454">
            <label slot="label" class="el-form-item__label">{{ $t('companies.form.input_labels.login_id') }} <span class="text-required">{{ $t('required') }}</span> </label>
            <el-input name="login_id" v-model="form.login_id" :placeholder="$t('companies.form.input_placeholder.login_id')" @blur="trim('login_id')"></el-input>
          </el-form-item>
          <el-form-item>
            <label slot="label" class="el-form-item__label">{{ $t('companies.form.input_labels.status') }} <span class="text-required">{{ $t('required') }}</span></label>
            <el-radio-group v-model="form.status">
                <el-radio label="1" name="status">{{ $t('status.active') }}</el-radio>
                <el-radio label="0" name="status">{{ $t('status.inactive') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <input type="hidden" name="_token" :value="csrf">
          <input type="hidden" name="industries" :value="form.industries">
          <input type="hidden" name="prefecture_id" :value="form.prefecture_id">
          <input type="hidden" name="id" :value="company.id" v-if="company && company.id">
          <el-form-item class="btn-container">
            <el-button type="primary" @click="submit('form')" class="btn btn-submit">{{ btn }}</el-button>
            <el-button @click="back" class="btn btn-back">{{ $t('back') }}</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </el-card>
</template>
<script>
  import { getAddressByZipcode } from '../../api/zipcode'
  export default {
    props: {
      prefectures: { type: Array, required: true, default: [] },
      industries: { type: Array, required: true, default: [] },
      errors: { type: Object, required: false },
      input: { type: Object, required: false },
      company: { type: Object, default: {} },
      urls: { type: Object, required: true, default: {} },
      btn: { type: String, required: true, default: '' },
    },
    data() {
      const checkRegexLoginId = (rule, value, callback) => {
        const regex = new RegExp(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,255}$/);
        if (!regex.test(value)) {
          callback(new Error(this.$t('errors.login_id.format')));
        } else {
          callback();
        }
      }
      const validateNumber = (rule, value, callback) => {
        const regex = new RegExp(/^-?[\d.]+(?:e-?\d+)?$/);
        if (!regex.test(value)) {
          callback(new Error(this.$t('errors.numeric', [this.$t('companies.form.zip_code')])))
        } else {
          callback()
        }
      }
      const checkRegexTel = (rule, value, callback) => {
        const regex = new RegExp(/^([0-9\s\-]*)$/);
        if (!regex.test(value)) {
          callback(new Error(this.$t('errors.tel_format')));
        } else {
          callback();
        }
      }
      const checkRegexNumber = (rule, value, callback) => {
        const regex = new RegExp(/^[0-9]+$/);
        if (!regex.test(value)) {
          callback(new Error(this.$t('errors.numeric', [this.$t('companies.form.input_labels.bank_account')])));
        } else {
          callback();
        }
      }
      const checkEmpty = (rule, value, callback) => {
        if (!value || value.trim().length === 0) {
          callback(new Error('error'));
        } else {
          callback();
        }
      }
      return {
        form: {
            name: '',
            industries: '',
            representative_name: '',
            zip_code: '',
            prefecture_id: '',
            city: '',
            address_number: '',
            house: '',
            tel: '',
            mail_address: '',
            homepage_url: '',
            memo: '',
            bank_name: '',
            branch_name: '',
            bank_account_type: '1',
            bank_account: '',
            bank_account_holder: '',
            login_id: '',
            status: '1',
        },
        rules: {
          name: [
            { validator: checkEmpty, message: this.$t('errors.required', [this.$t('companies.form.input_labels.name')]), trigger: 'blur' },
            { max: 255, message: this.$t('errors.max', [this.$t('companies.form.input_labels.name'), 255]), trigger: 'blur' },
          ],
          industries: [
            { required: true, message: this.$t('errors.required', [this.$t('companies.form.input_labels.industries')]), trigger: 'blur' },
          ],
          representative_name: [
            { validator: checkEmpty, message: this.$t('errors.required', [this.$t('companies.form.input_labels.representative_name')]), trigger: 'blur' },
            { max: 50, message: this.$t('errors.max', [this.$t('companies.form.input_labels.representative_name'), 50]), trigger: 'blur' },
          ],
          zip_code: [
            { required: true, message: this.$t('errors.required', [this.$t('companies.form.zip_code')]), trigger: 'blur' },
            { validator: validateNumber, trigger: 'blur' },
            { min: 7, max: 7, message: this.$t('errors.size.numeric', [this.$t('companies.form.zip_code'), 7]), trigger: 'blur' },
          ],
          prefecture_id: [
            { required: true, message: this.$t('errors.required', [this.$t('companies.form.input_labels.prefectures')]), trigger: 'blur' },
          ],
          city: [
            { validator: checkEmpty, message: this.$t('errors.required', [this.$t('companies.form.input_labels.city')]), trigger: 'blur' },
            { max: 50, message: this.$t('errors.max', [this.$t('companies.form.input_labels.city'), 50]), trigger: 'blur' },
          ],
          address_number: [
            { max: 50, message: this.$t('errors.max', [this.$t('companies.form.input_labels.address_number'), 50]), trigger: 'blur' },
          ],
          house: [
            { max: 100, message: this.$t('errors.max', [this.$t('companies.form.input_labels.house'), 100]), trigger: 'blur' },
          ],
          tel: [
            { validator: checkEmpty, message: this.$t('errors.required', [this.$t('companies.form.input_labels.tel')]), trigger: 'blur' },
            { max: 15, message: this.$t('errors.max', [this.$t('companies.form.input_labels.tel'), 15]), trigger: 'blur' },
            { validator: checkRegexTel, trigger: 'blur' },
          ],
          mail_address: [
            { validator: checkEmpty, message: this.$t('errors.required', [this.$t('companies.form.input_labels.mail_address')]), trigger: 'blur' },
            { max: 255, message: this.$t('errors.max', [this.$t('companies.form.input_labels.mail_address'), 255]), trigger: 'blur' },
            { type: "email", message: this.$t('errors.mail'), trigger: 'blur' }
          ],
          bank_name: [
            { validator: checkEmpty, message: this.$t('errors.required', [this.$t('companies.form.input_labels.bank_name')]), trigger: 'blur' },
            { max: 50, message: this.$t('errors.max', [this.$t('companies.form.input_labels.bank_name'), 50]), trigger: 'blur' },
          ],
          branch_name: [
            { validator: checkEmpty, message: this.$t('errors.required', [this.$t('companies.form.input_labels.branch_name')]), trigger: 'blur' },
            { max: 50, message: this.$t('errors.max', [this.$t('companies.form.input_labels.branch_name'), 50]), trigger: 'blur' },
          ],
          bank_account: [
            { validator: checkEmpty, message: this.$t('errors.required', [this.$t('companies.form.input_labels.bank_account')]), trigger: 'blur' },
            { max: 50, message: this.$t('errors.max', [this.$t('companies.form.input_labels.bank_account'), 50]), trigger: 'blur' },
            { validator: checkRegexNumber, trigger: 'blur' },
          ],
          bank_account_holder: [
            { validator: checkEmpty, message: this.$t('errors.required', [this.$t('companies.form.input_labels.bank_account_holder')]), trigger: 'blur' },
            { max: 255, message: this.$t('errors.max', [this.$t('companies.form.input_labels.bank_account_holder'), 255]), trigger: 'blur' },
          ],
          login_id: [
            { validator: checkEmpty, message: this.$t('errors.required', [this.$t('companies.form.login_id')]), trigger: 'blur' },
            { max: 255, message: this.$t('errors.max', [this.$t('companies.form.login_id'), 255]), trigger: 'blur' },
            { min: 8, message: this.$t('errors.min', [this.$t('companies.form.login_id'), 8]), trigger: 'blur' },
            { validator: checkRegexLoginId, trigger: 'blur' },
          ],
          status: [
            { required: true, message: this.$t('errors.required', [this.$t('companies.form.input_labels.status')]), trigger: 'blur' },
          ],
          homepage_url: [
            { max: 255, message: this.$t('errors.max', [this.$t('companies.form.input_labels.homepage_url'), 255]), trigger: 'blur' },
          ],
        },
        csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      }
    },
    methods: {
      submit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            document.querySelector(".el-container").classList.add("disabled");
            document.querySelector("#loader").style.display = "block";

            const form = document.getElementById("form");
            form.submit();
          } else {
            return false;
          }
        });
      },

      getAddressByZipcode() {
        getAddressByZipcode(this.form.zip_code)
        .then(response => response.json())
        .then(response => {
          if (response.status_code === 200) {
            this.form.prefecture_id = response.data.prefecture_id;
            this.form.address_number = response.data.address_number;
            this.form.city = response.data.city;
            this.$refs['form'].clearValidate(['prefecture_id', 'address_number', 'city', 'zip_code' ])
          }
        })
      },

      isErrorForField(field, errors) {
        return !(errors == null || errors.length == 0 || !errors.hasOwnProperty(field));
      },

      getErrorForField(field, errors) {
        return this.isErrorForField(field, errors) ? errors[field][0] : '';
      },

      back() {
        window.location.href = this.urls.back;
      },

      handleZipcode() {
        this.form.zip_code = this.form.zip_code.replace(/\D/g,'');
        if (this.form.zip_code.length > 7) {
          this.form.zip_code = this.form.zip_code.substr(0, 7);
        }
      },

      trim(field) {
        this.form[field] = this.form[field].trim();
      },

      validateSelect(filed) {
        this.$refs['form'].validateField(filed)
      },

      checkRequiredIndustries() {
        if (this.form.industries.length > 0) {
          this.$refs['form'].clearValidate('industries');
        }
        else {
          this.$refs['form'].validateField('industries');
        }
      }
    },

    created() {
      const tempData = (Object.keys(this.input).length === 0) ? this.company : this.input;
      this.form = Object.fromEntries(Object.entries(tempData).map(([key, value]) => [key, value]));
      this.form.status = (tempData.hasOwnProperty('status')) ? tempData.status.toString() : '1';
      this.form.bank_account_type = (tempData.hasOwnProperty('bank_account_type')) ? tempData.bank_account_type.toString() : '1';
      this.form.prefecture_id = (tempData.prefecture_id) ? parseInt(tempData.prefecture_id) : '';
      this.form.industries = (tempData.industries) ? tempData.industries.split(",").map(Number) : [];
      if (Object.keys(this.company).length > 0) {
        this.labelBtnSubmit = this.$t('update');
        this.action = 'update';
      }
   },
  }
</script>



